import React, { Fragment } from "react";
import { Button, Col, Collapse, Row, Table } from "reactstrap";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { dateHelpers, helpers } from "../utils";
import _ from "lodash";

export default function CollapseTable({ collapse, row, docNum, onChangeCallback, keyidx }) {
   const data = row.Details;

   function replacer(key, value) {
      // Encode # symbol in item string for inventory dashboard link
      if (typeof value === 'string')
         return value.replace(/#/g, '%23');

      return value;
   }

   return (
      <Fragment>
         <Row className="mb-1">
            <Col><Button className="shredButton pt-0" size="sm" onClick={() => onChangeCallback(docNum)}>{collapse ? <FaMinusCircle /> : <FaPlusCircle />}</Button></Col>
            <Col>{row.ModType}</Col>
            <Col>{row.DocType}</Col>
            <Col>{dateHelpers.toLongDateString(row.DocDate)}</Col>
            <Col xs="2">{row.DocNum}</Col>
            <Col>{row.Location}</Col>
            <Col>{row.UofM}</Col>
            <Col>{row.Qty}</Col>
            <Col>{helpers.formatCurrency(row.UnitCost)}</Col>
            <Col>{helpers.formatCurrency(row.ExtCost)}</Col>
            <Col>{row.CustVend}</Col>
            {/* <Col></Col> */}
         </Row>

         <Collapse isOpen={collapse} className="px-5">
            <Table size="sm" className="data-table">
               <thead className="table-header">
                  <tr>
                     <th style={{ width: "25%" }}>Item</th>
                     <th>Loc</th>
                     <th>UOFM</th>
                     <th>Qty</th>
                     <th>Cost</th>
                     <th>To Loc</th>
                     <th>Reason</th>
                  </tr>
               </thead>
               <tbody>
                  {data.length > 0 && _.map(data, (datum, index) => {
                     return (
                        <tr key={index}
                        // className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                        >
                           <td className={"data-cell"} children={
                              <span onClick={() => window.open(`/inventoryDashboard/${JSON.stringify({ value: datum.ItemNumber, label: datum.ItemWithDesc }, replacer)}`, '_blank')} className="shredLink fw-bold">
                                 {datum.ItemWithDesc}
                              </span>
                           } />
                           <td className={"data-cell"} children={datum.Location} />
                           <td className={"data-cell"} children={datum.UOFM} />
                           <td className={"data-cell"} style={{ color: datum.Qty < 0 ? "red" : "black" }} children={datum.Qty} />
                           <td className={"data-cell"} children={helpers.formatCurrency(datum.UnitCost)} />
                           <td className={"data-cell"} children={datum.ToLocation} />
                           <td className={"data-cell"} children={datum.Reason} />
                        </tr>
                     );
                  })}
               </tbody>
            </Table>
         </Collapse>
      </Fragment>
   );
}